import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Event as EventModel } from '../../../core/models/event.model';
import { EventService } from '../../../core/services/event.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-event-step',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatCardModule, MatSelectModule, MatButtonModule],
  templateUrl: './event-step.component.html',
  styleUrls: ['./event-step.component.scss'],
  providers: [EventService]
})
export class EventStepComponent implements OnInit {
  @Output() eventSelected = new EventEmitter<EventModel>();

  events: EventModel[] = [];
  isLoadingEvents = false;
  eventForm: FormGroup;

  constructor(private fb: FormBuilder, private eventService: EventService) {
    this.eventForm = this.fb.group({
      event: [null, Validators.required]
    });
  }

  ngOnInit() {
    if (environment.FIXED_EVENT) {
      this.events = [environment.FIXED_EVENT];
     // this.eventForm.get('event')?.setValue(environment.FIXED_EVENT);
      //this.eventSelected.emit(environment.FIXED_EVENT);
    } else {
      this.loadEvents();
    }
  }

  loadEvents() {
    this.isLoadingEvents = true;
    this.eventService.getOngoingEvents().subscribe({
      next: (data: EventModel[]) => {
        this.events = data;
        this.isLoadingEvents = false;
        // if (this.events.length > 0) {
        //   //this.eventForm.get('event')?.setValue(this.events[0]);
        //   this.eventSelected.emit(this.events[0]);
        // }
      },
      error: () => {
        this.isLoadingEvents = false;
      }
    });
  }

  onEventSelected(event: EventModel) {
    this.eventForm.get('event')?.setValue(event);
    this.eventSelected.emit(event);
  }

  submit() {
    if (this.eventForm.valid) {
      this.eventSelected.emit(this.eventForm.value.event);
    }
  }
}
